import cnConst from './cnConst/cnConst'

const Const = cnConst
export default Const



// WEBPACK FOOTER //
// ./src/Const.js